export default "480d09944a6d82504d14e68cff82886a.png";